import { TableConfig } from '../../../components/table/Table';

export const initAdressmanagementTableConfig = (): TableConfig => {
  return [
    {
      id: 1,
      columnName: 'Matchcode',
      attributName: 'matchcode',
      valueType: 'string',
    },
    {
      id: 2,
      columnName: 'Nummer',
      attributName: 'fremdnummer',
      valueType: 'string',
    },
    {
      id: 3,
      columnName: 'Name',
      attributName: 'name',
      valueType: 'string',
    },
    {
      id: 4,
      columnName: 'Zeile 2',
      attributName: 'zeile2',
      valueType: 'string',
    },
    {
      id: 5,
      columnName: 'LKZ',
      attributName: 'lkz',
      valueType: 'string',
    },
    {
      id: 6,
      columnName: 'PLZ',
      attributName: 'plz',
      valueType: 'string',
    },
    {
      id: 7,
      columnName: 'Ort',
      attributName: 'ort',
      valueType: 'string',
    },
    {
      id: 8,
      columnName: 'Ortsteil',
      attributName: 'ortsteil',
      valueType: 'string',
    },
    {
      id: 9,
      columnName: 'Straße',
      attributName: 'strasse',
      valueType: 'string',
    },
    {
      id: 10,
      columnName: 'Kontakt',
      attributName: 'kontakt',
      valueType: 'string',
    },
    {
      id: 11,
      columnName: 'Telefon',
      attributName: 'telefon',
      valueType: 'string',
    },
  ];
};
